import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const RxGhgAccordion = forwardRef(function RxGhgAccordion(
  { id, title, subtitle, rightEl, children, defaultExpanded = true },
  ref
) {
  const [expanded, setExpanded] = useState(Boolean(defaultExpanded));

  const headerId = useMemo(() => `${id}-header`, [id]);
  const contentId = useMemo(() => `${id}-content`, [id]);

  useImperativeHandle(
    ref,
    () => ({
      expand: () => setExpanded(true),
      collapse: () => setExpanded(false),
      isExpanded: () => Boolean(expanded),
    }),
    [expanded]
  );

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, next) => setExpanded(Boolean(next))}
      disableGutters
      className="rxghg_acc"
      id={id}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={contentId}
        id={headerId}
        className="rxghg_accHead"
      >
        <Box className="rxghg_accHeadLeft">
          <Typography className="rxghg_accTitle">{title}</Typography>
          {subtitle ? <Typography className="rxghg_accSub">{subtitle}</Typography> : null}
        </Box>

        {rightEl ? (
          <Box className="rxghg_accHeadRight" onClick={(e) => e.stopPropagation()}>
            {rightEl}
          </Box>
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="rxghg_accBody">{children}</AccordionDetails>
    </Accordion>
  );
});

export default RxGhgAccordion;
